<template>
  <span>{{ priceString }}</span>
</template>

<script>
// import Logger from "@/logger";
// const logger = new Logger("views/matching/components/ItemCardPrice");
import { createNamespacedHelpers } from "vuex";

const { mapState } = createNamespacedHelpers("matching");

/**
 * A component that renders the price of the item if it does not have
 * a `productId` or a range of prices with the min and max prices from
 * all the items of its QMP.
 *
 * If the item does not have a price nor a QMP it will show a message
 * indicating that the item does not have a price to show.
 */
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    /* This flag indicates if the item is the cover page of the qmp and it must show
    the price range or only the item's price */
    qmpCoverPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["similarItemsQmps"]),
    /**
     * Generate the string that indicates the price of the item or
     * the range of prices of its QMP (if it has one).
     */
    priceString() {
      const itemPriceString = this.item.price
        ? this.item.price.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
          })
        : "Sin precio";

      if (!this.qmpCoverPage || !this.qmp || !this.qmp.items.length) {
        return itemPriceString;
      }

      const prices = Object.entries(this.qmp.items)
        .map(([, value]) => value.price)
        .filter((price) => price != null);

      // logger.log(`${this.item.productId}: ${prices}`);

      const maxPrice = Math.max(...prices);
      const minPrice = Math.min(...prices);

      // logger.log(
      //   `${this.item.productId}: ${minPrice.toLocaleString("es-CL", {
      //     style: "currency",
      //     currency: "CLP",
      //   })} - ${maxPrice.toLocaleString("es-CL", {
      //     style: "currency",
      //     currency: "CLP",
      //   })}`
      // );

      /* Return the range only if we have a range with min and max values */
      if (prices.length > 0 && minPrice !== maxPrice) {
        return `${minPrice.toLocaleString("es-CL", {
          style: "currency",
          currency: "CLP",
        })} - ${maxPrice.toLocaleString("es-CL", {
          style: "currency",
          currency: "CLP",
        })}`;
      }

      /* Return the item's price if we don't have a range */
      return itemPriceString.toLocaleString("es-CL", {
        style: "currency",
        currency: "CLP",
      });
    },
    /**
     * Get the QMP asssociated to the given item using its `productId`.
     */
    qmp() {
      return this.similarItemsQmps[this.item.productId];
    },
  },
};
</script>